<nx-formfield label="Language" class="language-dropdown-formfield">
  <nx-dropdown
    [value]="selectedLang"
    (valueChange)="onLanguageChange($event)"
  >
    @for (language of languages; track language.code) {
      <nx-dropdown-item [value]="language.code">{{ language.label }}</nx-dropdown-item>
    }
  </nx-dropdown>
</nx-formfield>
